import { eduDemoResponders, type EduDemoResponder } from './eduDemoResponders'

export function getEduDemoResponder(handlerName: string): EduDemoResponder | undefined {
  return eduDemoResponders[handlerName]
}

export function hasEduDemoResponder(handlerName: string): boolean {
  return typeof eduDemoResponders[handlerName] === 'function'
}
